export default __webpack_public_path__ + "static/media/ILUSTRACIONES_12.cea632ff.png";